import api from '../../services/api';

const urlBase = '/manutencoes-veiculos';

export default {
	listar: () => api.get(urlBase),
	criar: (data) => api.post(urlBase, data),
	atualizar: (id, data) => api.put(`${urlBase}/${id}`, data),
	excluir: (id) => api.delete(`${urlBase}/${id}`),
};